export const REFERENCES_SET_LISTS = 'REFERENCES_SET_LISTS';
export const REFERENCES_SET_LOADING = 'REFERENCES_SET_LOADING';
export const REFERENCES_ALL_SET_LISTS = 'REFERENCES_ALL_SET_LISTS';
/* CDR */
export const CDR_SET_LOADING = 'CDR_SET_LOADING';
export const CDR_GET_LIST_SUCCESS = 'CDR_GET_LIST_SUCCESS';

/* TRAFFIC REPORTS */
export const TRAFFIC_REPORTS_SET_LOADING = 'TRAFFIC_REPORTS_SET_LOADING';
export const TRAFFIC_REPORTS_GET_LIST_SUCCESS = 'TRAFFIC_REPORTS_GET_LIST_SUCCESS';

/* AUTH */
export const NEED_SECOND_AUTH = 'NEED_SECOND_AUTH';
export const SET_PERMISSION = 'SET_PERMISSION';
export const SET_PERMISSION_ADD = 'SET_PERMISSION_ADD';

/* SIM TRAFFIC RANGES */
export const SIM_TRAFFIC_RANGES_SET_LOADING = 'SIM_TRAFFIC_RANGES_SET_LOADING';
export const SIM_TRAFFIC_RANGES_SET_LIST = 'SIM_TRAFFIC_RANGES_SET_LIST';

/* BLOCKED DESTINATIONS */
export const BLOCKED_DESTINATIONS_SET_LOADING = 'BLOCKED_DESTINATIONS_SET_LOADING';
export const BLOCKED_DESTINATIONS_SET_LIST = 'BLOCKED_DESTINATIONS_SET_LIST';

/* GLOBAL SETTINGS */
export const GLOBAL_SETTING_SET_LOADING = 'GLOBAL_SETTING_SET_LOADING';
export const GLOBAL_SETTING_SET_LIST = 'GLOBAL_SETTING_SET_LIST';